import * as React from 'react';
import { colors } from '../../../index';

const IconNoResult = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 30 38",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.143 22.143c0-1.972-1.6-3.572-3.572-3.572v3.572h3.572z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 22.143c0-3.304-2.505-6.03-5.714-6.387V7.02a2.13 2.13 0 00-.628-1.515L18.78.628A2.13 2.13 0 0017.266 0H2.143A2.145 2.145 0 000 2.143v27.143c0 1.181.961 2.143 2.143 2.143h17.143V30H2.143a.715.715 0 01-.714-.714V2.143c0-.394.32-.714.714-.714h15V5c0 1.181.961 2.143 2.143 2.143h3.571v8.613c-3.21.358-5.714 3.083-5.714 6.387 0 3.303 2.505 6.03 5.714 6.386V30h-2.143v5c0 1.181.962 2.143 2.143 2.143h1.429A2.145 2.145 0 0026.429 35v-5h-2.143v-1.47C27.495 28.171 30 25.445 30 22.142zm-5.714 13.571h-1.429a.715.715 0 01-.714-.714v-.714H25V35c0 .394-.32.714-.714.714zM25 32.857h-2.857V31.43H25v1.428zM18.571 5V2.439l3.276 3.275h-2.561A.715.715 0 0118.57 5zm0 17.143c0-2.757 2.244-5 5-5 2.757 0 5 2.243 5 5 0 2.756-2.243 5-5 5-2.756 0-5-2.244-5-5z"
  }));
};

export default IconNoResult;